import type { FormField, FormSchema } from '@cli-types/core-engine/schema.js'
import { SORTABLE_FORM_FIELD_TYPES } from '@cli-constants/schema-codegen.js'

export function getSortableSubmissionFields(schema: FormSchema, fields: FormField[]): string[] {
  if (schema.columns && schema.columns.length > 0) {
    return Array.from(
      new Set(
        schema.columns.filter((column) => column.sortable).map((column) => column.accessorKey)
      )
    )
  }

  return Array.from(
    new Set(
      fields
        .filter((field): field is FormField & { name: string } => Boolean(field.name))
        .filter((field) => SORTABLE_FORM_FIELD_TYPES.has(field.type))
        .map((field) => field.name)
    )
  )
}
